export const PARTYSTOCK_FETCH_SUCCESS = 'PARTYSTOCK_FETCH_SUCCESS';
export const PARTYSTOCK_FETCH_ERROR = 'PARTYSTOCK_FETCH_ERROR';
export const PARTYSTOCK_REMOVE_DATA = 'PARTYSTOCK_REMOVE_DATA';
